/*
 * Copyright (c) 2020.
 * Simon
 */

import {SERVER_API_PLATFORMJK} from '../../../constans/index';
import {RSAA} from 'redux-api-middleware';
import headers from "../../../utils/headers";
import {
    FANPAGE_GET_STARTED_STATUS_FAILURE,
    FANPAGE_GET_STARTED_STATUS_REQUEST,
    FANPAGE_GET_STARTED_STATUS_UPDATE
} from "../../../types/index";

/**
 * GetStartedStatusAction
 */
const GetStartedStatusAction = (page_id, method) => ({

    [RSAA]: {
        endpoint: () => {
            return `${SERVER_API_PLATFORMJK}/api/pages/${page_id}/started`
        },
        method: method,
        headers: (headers()),
        types: [
            FANPAGE_GET_STARTED_STATUS_REQUEST,
            {
                type: FANPAGE_GET_STARTED_STATUS_UPDATE,
                payload: async (action, state, res) => {
                    let data = [];
                    await res.json().then((json) => {
                        data = json.data
                    });

                    return {
                        "code": 0,
                        "type": FANPAGE_GET_STARTED_STATUS_UPDATE,
                        "method": method,
                        "data": data,
                    }
                }
            },
            {
                type: FANPAGE_GET_STARTED_STATUS_FAILURE,
                payload: async (action, state, res) => {

                    let message = "";
                    await res.json().then((json) => {
                        message = json.message;
                    });

                    return {
                        "code": 1,
                        "type": FANPAGE_GET_STARTED_STATUS_FAILURE,
                        "method": method,
                        "message": message,
                        "data": [],
                    }
                }
            }
        ]
    }

});

export {GetStartedStatusAction}